// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@property --white-color{
    syntax: "<color>";
    inherits: false;
    initial-value: #FFFFFF;
}

@property --black-color {
    syntax: "<color>";
    inherits: false;
    initial-value: #000000;
}


@property --blue-color {
    syntax: "<color>";
    inherits: false;
    initial-value: #a100ff;
}


@property --purple-color {
    syntax: "<color>";
    inherits: false;
    initial-value: deeppink;
}

@property --indigo-color {
    syntax: "<color>";
    inherits: false;
    initial-value: #3171e0;
}

:root {
    --font-size-xsm: 0.75rem;
    --font-size-sm: 0.875rem;
    --font-size: 1rem;
    --font-size-lg: 1.125rem;
    --font-size-xl: 1.25rem;
    --font-size-xxl: 1.5rem;

    --pico-primary: var(--purple-color) !important;
    --pico-primary-background: var(--purple-color) !important;
    --pico-primary-hover: var(--purple-color) !important;
    --pico-primary-focus: #0056b3 !important;


}

input {
    border-color: var(--purple-color) !important;
    border-width: 0.15rem !important;
    box-shadow: inset 0 0 15px gray !important;
    /*box-shadow: inset 5px 10px 10px rgba(0, 0, 0, 0.9) !important;*/
}

button {
    border: 3px outset var(--purple-color) !important;
    /*color: black !important;*/
    font-weight: bold !important;
    font-size: 1rem;
    border-radius: 0.5rem !important;
    padding:1rem 0rem;


    --background: linear-gradient(160deg, #ff11a5 20%, #5200ff 80%);
    --background-activated: linear-gradient(160deg, deeppink 20%, #007bff 80%); /* Optional: Different gradient for active state */
    --background-focused: linear-gradient(160deg, deeppink 20%, #007bff 80%); /* Optional: Different gradient for focused state */
    --background-hover: linear-gradient(160deg, deeppink 20%, #007bff 80%); /* Optional: Different gradient for hover state */
    
    color: white; /* Ensure text color contrasts with the background */
    /*border:2px outset silver;*/
    /*border-radius:0.5rem;
    /*font-weight:bold;*/
}


button:focus {
    background-color: var(--purple-color) !important; /* Match hover or active */
    outline: none; /* Optional: suppress outline */
    border: 3px solid var(--purple-color) !important;
}


/*button:active, button:focus,button:hover{*/
/*    border:3px solid var(--purple-color) !important;*/
/*    color:black!important;*/
/*    font-weight: bold !important;*/
/*}*/

button.outline {
    border: 3px outset var(--purple-color) !important;
    background-color: transparent !important;
    color: var(--purple-color) !important;
    font-weight: bold;
}




@keyframes glowing {
    0% {
        box-shadow: 0 0 20px 5px var(--blue-color);
    }
    100% {
        box-shadow: 0 0 0px 0px var(--purple-color);
    }
}

@keyframes textclip {
    0% {
        background-position: 200% center;
    }
    100% {
        background-position: 0% center;
    }
}

.animate-glow {
    animation: glowing 1000ms infinite alternate-reverse;
}

.xl {
    padding: 1rem;
    font-weight: bold;
    width: 100%;
    min-height: 60px; /* Add this line */
    border: 0.25rem solid var(--pico-primary);
    border-radius: 0.5rem;
}

.animate-content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    background-image: linear-gradient(-230deg, white 70%, black 30%);
    background-size: 200% auto;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: textclip 2000ms infinite ease;
}

/* remove sparkle concept*/
.sparkle {
    background: linear-gradient(160deg, var(--blue-color), 20%, var(--purple-color) 80%);
    display: inline-block;
    font-weight: bold; /*\$btn-font-weight*/
    color: #fff;
    text-align: center;
    vertical-align: middle;
    user-select: none;
    background-color: transparent;
    border: 3px outset var(--blue-color);
    /*\$btn-border-width*/
    padding: 0.375rem 0.75rem;
    border-radius: 0.4rem;
}

.text-gradient {
    background: linear-gradient(160deg, var(--blue-color), 40%, var(--purple-color) 60%);
    color: transparent;
    -webkit-background-clip: text;
    background-clip: text;
}

.text-gradient-warm {
    background-image: linear-gradient(135deg, #F2CD48 0%, #FD803F 100%);
    color: transparent;
    -webkit-background-clip: text;
    background-clip: text;
}

.text-gradient-hot {
    background-image: linear-gradient(135deg, #F9445A 0%, #FD803F 100%);
    color: transparent;
    -webkit-background-clip: text;
    background-clip: text;
}

.text-gradient-cold {
    background-image: linear-gradient(135deg, #8019C6 0%, #2F93CC 100%);
    color: transparent;
    -webkit-background-clip: text;
    background-clip: text;
}

.alert {
    
}

.alert.alert-error {
    border: 2px solid hotpink;
    background-color:hotpink;
    margin-bottom: 10px
}

.alert.alert-warning {
    border: 0.50rem solid rgba(255, 255, 0, 1);
    background-color:rgba(255, 255, 0, 1);
    padding: 15px;
    margin-bottom: 10px;
    box-shadow: 5px 7px 5px black;
}

.alert h2, .alert p {
    color:black;
}

/*.alert p{*/
/*    color:white;*/
/*}*/

.alert ul {
    margin: 10px;
    padding: 0;

}

.alert ul li {
    padding: 0px;
    font-size: var(--font-size-sm);
    list-style: none;
    font-weight:bold;
    color:var(--black-color) !important;
}

.field-error {
    border-radius: 2px 2px 10px 10px;
    border: 0.15rem solid hotpink;
    background-color: hotpink;
    margin-bottom: 10px;
    margin-top: 2px;
}

.field-error-input {
    border-color: hotpink !important;
}

.field-error ul {
    margin: 10px;
    padding: 0;
}

.field-error li {
    padding: 0px;
    font-size: var(--font-size-sm);
    list-style: none;
    color: black;
    font-weight: bold;
}

.flex-grid {
    display: flex;
    flex-wrap: wrap;
    /*margin: -0.5rem;*/
}

.col {
    padding: 0.5rem;
    box-sizing: border-box;
}

/* 12-column system */
.col-1 {
    flex: 0 0 8.3333%;
    max-width: 8.3333%;
}

.col-2 {
    flex: 0 0 16.6667%;
    max-width: 16.6667%;
}

.col-3 {
    flex: 0 0 25%;
    max-width: 25%;
}

.col-4 {
    flex: 0 0 33.3333%;
    max-width: 33.3333%;
}

.col-5 {
    flex: 0 0 41.6667%;
    max-width: 41.6667%;
}

.col-6 {
    flex: 0 0 50%;
    max-width: 50%;
}

.col-7 {
    flex: 0 0 58.3333%;
    max-width: 58.3333%;
}

.col-8 {
    flex: 0 0 66.6667%;
    max-width: 66.6667%;
}

.col-9 {
    flex: 0 0 75%;
    max-width: 75%;
}

.col-10 {
    flex: 0 0 83.3333%;
    max-width: 83.3333%;
}

.col-11 {
    flex: 0 0 91.6667%;
    max-width: 91.6667%;
}

.col-12 {
    flex: 0 0 100%;
    max-width: 100%;
}


html {
    overflow-y: scroll;
}


:root {
    --pico-h4-color: #c2c7d0 !important;
    --pico-h5-color: #c2c7d0 !important;
    --pico-h6-color: #c2c7d0 !important;
}

/*@property --pico-h6-color {*/
/*    syntax: "<color>";*/
/*    inherits: false;*/
/*    initial-value: #f0f1f3;*/
/*}*/


h1, .h1 {
    font-size: clamp(1.5rem, 5vw, 2rem) !important;
    line-height: 1.125;
    --pico-typography-spacing-top: 3rem;
}

h2, .h2 {
    font-size: clamp(1.25rem, 4vw, 1.75rem) !important;
    line-height: 1.15 !important;
    --pico-typography-spacing-top: 2.625rem;
}

h3, .h3 {
    font-size: clamp(1.125rem, 3vw, 1.5rem) !important;
    line-height: 1.175 !important;
    --pico-typography-spacing-top: 2.25rem;
}

h4, .h4 {
    font-size: clamp(1rem, 2.5vw, 1.25rem) !important;
    line-height: 1.2 !important;
    --pico-typography-spacing-top: 1.874rem;
}

h5, .h5 {
    font-size: clamp(0.9375rem, 2vw, 1.125rem) !important;
    line-height: 1.225 !important;
    --pico-typography-spacing-top: 1.6875rem;
}

h6, .h6 {
    font-size: clamp(0.875rem, 1.5vw, 1rem) !important;
    line-height: 1.25 !important;
    --pico-typography-spacing-top: 1.5rem;
}

.h7 {
    font-size: clamp(0.8125rem, 1.25vw, 0.9375rem) !important;
    line-height: 1 !important;
    --pico-typography-spacing-top: 1.3125rem;
    font-weight: 700 !important;
}

.h8 {
    font-size: clamp(0.75rem, 1vw, 0.875rem) !important;
    line-height: 1 !important;
    --pico-typography-spacing-top: 1.125rem;
    font-weight: 700 !important;
}


h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
    font-weight: 700 !important;
}

/*h1, .h1 {*/
/*    font-size: 2rem !important;*/
/*    line-height: 1.125;*/
/*    --pico-typography-spacing-top: 3rem*/
/*}*/

/*h2, .h2 {*/
/*    font-size: 1.75rem !important;*/
/*    --pico-line-height: 1.15 !important;*/
/*    --pico-typography-spacing-top: 2.625rem*/
/*}*/

/*h3, .h3 {*/
/*    font-size: 1.5rem !important;*/
/*    --pico-line-height: 1.175 !important;*/
/*    --pico-typography-spacing-top: 2.25rem*/
/*}*/

/*h4, .h4 {*/
/*    font-size: 1.25rem !important;;*/
/*    line-height: 1.2 !important;;*/
/*    --pico-typography-spacing-top: 1.874rem*/
/*}*/

/*h5, .h5 {*/
/*    font-size: 1.125rem !important;;*/
/*    line-height: 1.225 !important;;*/
/*    --pico-typography-spacing-top: 1.6875rem*/
/*}*/

/*h6, .h6 {*/
/*    font-size: 1rem !important;;*/
/*    line-height: 1.25 !important;;*/
/*    --pico-typography-spacing-top: 1.5rem*/
/*}*/

.disabled {
    background: silver;
    border: 3px solid silver !important;
    animation: none;
}

.disabled .animate-content {
    animation: none
}

/*nav ul li{*/
/*    margin:0;*/
/*    padding:5px;*/
/*}*/

nav {
    display: flex;
    align-items: center; /* <- ensures vertical centering of children */
    justify-content: space-between;
    /*background-color: black;*/
    padding: 0px 0px;
    /*height: 100%;*/ /* or however tall you want the navbar */
}

nav li {
    padding: 10px !important;
    margin: 0 !important;
}


.page-title {
    border-bottom: 1px solid #2f2f2f;
    margin-bottom: 0.5rem;
}

.page-title h1 {
    padding: 0px;
    margin: 0.5rem 0rem;
}

.container.screen-view{
    padding:0px;
    max-width:600px !important;
}

html, body {
    height: 100%;
    margin: 0;
    display: flex;
    flex-direction: column;
}

body > .container {
    flex: 1 0 auto; /* grow and shrink, but don't disappear */
    display: flex;
    flex-direction: column;
}

#app {
    flex: 1 0 auto; /* make app area grow to fill vertical space */
}

#header{
    padding:0rem 1rem;
    background-color: #010110;
    margin-bottom:0.5rem;
    
}

.footer {
    flex-shrink: 0;
    text-align: center;
    margin-top: auto;
    padding: 0.5rem;
    letter-spacing: 0px;
    color: lightgray;
    font-size: .6rem;
    font-family: 'Helvetica', sans-serif;
    font-weight: bolder;
}


body {
    overflow-y: visible;
}

`, "",{"version":3,"sources":["webpack://./src/css/main.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;;;AAGA;IACI,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;;;AAGA;IACI,iBAAiB;IACjB,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,wBAAwB;IACxB,iBAAiB;IACjB,wBAAwB;IACxB,uBAAuB;IACvB,uBAAuB;;IAEvB,8CAA8C;IAC9C,yDAAyD;IACzD,oDAAoD;IACpD,wCAAwC;;;AAG5C;;AAEA;IACI,4CAA4C;IAC5C,gCAAgC;IAChC,0CAA0C;IAC1C,iEAAiE;AACrE;;AAEA;IACI,iDAAiD;IACjD,2BAA2B;IAC3B,4BAA4B;IAC5B,eAAe;IACf,gCAAgC;IAChC,iBAAiB;;;IAGjB,+DAA+D;IAC/D,0EAA0E,EAAE,kDAAkD;IAC9H,wEAAwE,EAAE,mDAAmD;IAC7H,sEAAsE,EAAE,iDAAiD;;IAEzH,YAAY,EAAE,oDAAoD;IAClE,4BAA4B;IAC5B;wBACoB;AACxB;;;AAGA;IACI,gDAAgD,EAAE,0BAA0B;IAC5E,aAAa,EAAE,+BAA+B;IAC9C,gDAAgD;AACpD;;;AAGA,4CAA4C;AAC5C,uDAAuD;AACvD,6BAA6B;AAC7B,oCAAoC;AACpC,IAAI;;AAEJ;IACI,iDAAiD;IACjD,wCAAwC;IACxC,qCAAqC;IACrC,iBAAiB;AACrB;;;;;AAKA;IACI;QACI,0CAA0C;IAC9C;IACA;QACI,2CAA2C;IAC/C;AACJ;;AAEA;IACI;QACI,gCAAgC;IACpC;IACA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;IACX,gBAAgB,EAAE,kBAAkB;IACpC,yCAAyC;IACzC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;;IAEZ,gEAAgE;IAChE,0BAA0B;IAC1B,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;IACpC,wCAAwC;AAC5C;;AAEA,0BAA0B;AAC1B;IACI,oFAAoF;IACpF,qBAAqB;IACrB,iBAAiB,EAAE,mBAAmB;IACtC,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,6BAA6B;IAC7B,oCAAoC;IACpC,oBAAoB;IACpB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,oFAAoF;IACpF,kBAAkB;IAClB,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,mEAAmE;IACnE,kBAAkB;IAClB,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,mEAAmE;IACnE,kBAAkB;IAClB,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;IACI,mEAAmE;IACnE,kBAAkB;IAClB,6BAA6B;IAC7B,qBAAqB;AACzB;;AAEA;;AAEA;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB;AACJ;;AAEA;IACI,0CAA0C;IAC1C,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA,YAAY;AACZ,mBAAmB;AACnB,IAAI;;AAEJ;IACI,YAAY;IACZ,UAAU;;AAEd;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;IAC7B,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,sBAAsB;AAC1B;;AAEA,qBAAqB;AACrB;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;;AAGA;IACI,kBAAkB;AACtB;;;AAGA;IACI,mCAAmC;IACnC,mCAAmC;IACnC,mCAAmC;AACvC;;AAEA,8BAA8B;AAC9B,yBAAyB;AACzB,uBAAuB;AACvB,8BAA8B;AAC9B,IAAI;;;AAGJ;IACI,8CAA8C;IAC9C,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,kDAAkD;IAClD,4BAA4B;IAC5B,uCAAuC;AAC3C;;AAEA;IACI,kDAAkD;IAClD,6BAA6B;IAC7B,sCAAsC;AAC1C;;AAEA;IACI,iDAAiD;IACjD,2BAA2B;IAC3B,uCAAuC;AAC3C;;AAEA;IACI,qDAAqD;IACrD,6BAA6B;IAC7B,wCAAwC;AAC5C;;AAEA;IACI,kDAAkD;IAClD,4BAA4B;IAC5B,qCAAqC;AACzC;;AAEA;IACI,yDAAyD;IACzD,yBAAyB;IACzB,wCAAwC;IACxC,2BAA2B;AAC/B;;AAEA;IACI,mDAAmD;IACnD,yBAAyB;IACzB,uCAAuC;IACvC,2BAA2B;AAC/B;;;AAGA;IACI,2BAA2B;AAC/B;;AAEA,YAAY;AACZ,kCAAkC;AAClC,0BAA0B;AAC1B,0CAA0C;AAC1C,IAAI;;AAEJ,YAAY;AACZ,qCAAqC;AACrC,2CAA2C;AAC3C,8CAA8C;AAC9C,IAAI;;AAEJ,YAAY;AACZ,oCAAoC;AACpC,4CAA4C;AAC5C,6CAA6C;AAC7C,IAAI;;AAEJ,YAAY;AACZ,sCAAsC;AACtC,oCAAoC;AACpC,8CAA8C;AAC9C,IAAI;;AAEJ,YAAY;AACZ,uCAAuC;AACvC,sCAAsC;AACtC,+CAA+C;AAC/C,IAAI;;AAEJ,YAAY;AACZ,mCAAmC;AACnC,qCAAqC;AACrC,4CAA4C;AAC5C,IAAI;;AAEJ;IACI,kBAAkB;IAClB,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI;AACJ;;AAEA,aAAa;AACb,gBAAgB;AAChB,mBAAmB;AACnB,IAAI;;AAEJ;IACI,aAAa;IACb,mBAAmB,EAAE,8CAA8C;IACnE,8BAA8B;IAC9B,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB,EAAE,wCAAwC;AAC9D;;AAEA;IACI,wBAAwB;IACxB,oBAAoB;AACxB;;;AAGA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc,EAAE,yCAAyC;IACzD,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,cAAc,EAAE,8CAA8C;AAClE;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,oBAAoB;;AAExB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,oCAAoC;IACpC,mBAAmB;AACvB;;;AAGA;IACI,mBAAmB;AACvB","sourcesContent":["@property --white-color{\n    syntax: \"<color>\";\n    inherits: false;\n    initial-value: #FFFFFF;\n}\n\n@property --black-color {\n    syntax: \"<color>\";\n    inherits: false;\n    initial-value: #000000;\n}\n\n\n@property --blue-color {\n    syntax: \"<color>\";\n    inherits: false;\n    initial-value: #a100ff;\n}\n\n\n@property --purple-color {\n    syntax: \"<color>\";\n    inherits: false;\n    initial-value: deeppink;\n}\n\n@property --indigo-color {\n    syntax: \"<color>\";\n    inherits: false;\n    initial-value: #3171e0;\n}\n\n:root {\n    --font-size-xsm: 0.75rem;\n    --font-size-sm: 0.875rem;\n    --font-size: 1rem;\n    --font-size-lg: 1.125rem;\n    --font-size-xl: 1.25rem;\n    --font-size-xxl: 1.5rem;\n\n    --pico-primary: var(--purple-color) !important;\n    --pico-primary-background: var(--purple-color) !important;\n    --pico-primary-hover: var(--purple-color) !important;\n    --pico-primary-focus: #0056b3 !important;\n\n\n}\n\ninput {\n    border-color: var(--purple-color) !important;\n    border-width: 0.15rem !important;\n    box-shadow: inset 0 0 15px gray !important;\n    /*box-shadow: inset 5px 10px 10px rgba(0, 0, 0, 0.9) !important;*/\n}\n\nbutton {\n    border: 3px outset var(--purple-color) !important;\n    /*color: black !important;*/\n    font-weight: bold !important;\n    font-size: 1rem;\n    border-radius: 0.5rem !important;\n    padding:1rem 0rem;\n\n\n    --background: linear-gradient(160deg, #ff11a5 20%, #5200ff 80%);\n    --background-activated: linear-gradient(160deg, deeppink 20%, #007bff 80%); /* Optional: Different gradient for active state */\n    --background-focused: linear-gradient(160deg, deeppink 20%, #007bff 80%); /* Optional: Different gradient for focused state */\n    --background-hover: linear-gradient(160deg, deeppink 20%, #007bff 80%); /* Optional: Different gradient for hover state */\n    \n    color: white; /* Ensure text color contrasts with the background */\n    /*border:2px outset silver;*/\n    /*border-radius:0.5rem;\n    /*font-weight:bold;*/\n}\n\n\nbutton:focus {\n    background-color: var(--purple-color) !important; /* Match hover or active */\n    outline: none; /* Optional: suppress outline */\n    border: 3px solid var(--purple-color) !important;\n}\n\n\n/*button:active, button:focus,button:hover{*/\n/*    border:3px solid var(--purple-color) !important;*/\n/*    color:black!important;*/\n/*    font-weight: bold !important;*/\n/*}*/\n\nbutton.outline {\n    border: 3px outset var(--purple-color) !important;\n    background-color: transparent !important;\n    color: var(--purple-color) !important;\n    font-weight: bold;\n}\n\n\n\n\n@keyframes glowing {\n    0% {\n        box-shadow: 0 0 20px 5px var(--blue-color);\n    }\n    100% {\n        box-shadow: 0 0 0px 0px var(--purple-color);\n    }\n}\n\n@keyframes textclip {\n    0% {\n        background-position: 200% center;\n    }\n    100% {\n        background-position: 0% center;\n    }\n}\n\n.animate-glow {\n    animation: glowing 1000ms infinite alternate-reverse;\n}\n\n.xl {\n    padding: 1rem;\n    font-weight: bold;\n    width: 100%;\n    min-height: 60px; /* Add this line */\n    border: 0.25rem solid var(--pico-primary);\n    border-radius: 0.5rem;\n}\n\n.animate-content {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n\n    background-image: linear-gradient(-230deg, white 70%, black 30%);\n    background-size: 200% auto;\n    background-clip: text;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    animation: textclip 2000ms infinite ease;\n}\n\n/* remove sparkle concept*/\n.sparkle {\n    background: linear-gradient(160deg, var(--blue-color), 20%, var(--purple-color) 80%);\n    display: inline-block;\n    font-weight: bold; /*$btn-font-weight*/\n    color: #fff;\n    text-align: center;\n    vertical-align: middle;\n    user-select: none;\n    background-color: transparent;\n    border: 3px outset var(--blue-color);\n    /*$btn-border-width*/\n    padding: 0.375rem 0.75rem;\n    border-radius: 0.4rem;\n}\n\n.text-gradient {\n    background: linear-gradient(160deg, var(--blue-color), 40%, var(--purple-color) 60%);\n    color: transparent;\n    -webkit-background-clip: text;\n    background-clip: text;\n}\n\n.text-gradient-warm {\n    background-image: linear-gradient(135deg, #F2CD48 0%, #FD803F 100%);\n    color: transparent;\n    -webkit-background-clip: text;\n    background-clip: text;\n}\n\n.text-gradient-hot {\n    background-image: linear-gradient(135deg, #F9445A 0%, #FD803F 100%);\n    color: transparent;\n    -webkit-background-clip: text;\n    background-clip: text;\n}\n\n.text-gradient-cold {\n    background-image: linear-gradient(135deg, #8019C6 0%, #2F93CC 100%);\n    color: transparent;\n    -webkit-background-clip: text;\n    background-clip: text;\n}\n\n.alert {\n    \n}\n\n.alert.alert-error {\n    border: 2px solid hotpink;\n    background-color:hotpink;\n    margin-bottom: 10px\n}\n\n.alert.alert-warning {\n    border: 0.50rem solid rgba(255, 255, 0, 1);\n    background-color:rgba(255, 255, 0, 1);\n    padding: 15px;\n    margin-bottom: 10px;\n    box-shadow: 5px 7px 5px black;\n}\n\n.alert h2, .alert p {\n    color:black;\n}\n\n/*.alert p{*/\n/*    color:white;*/\n/*}*/\n\n.alert ul {\n    margin: 10px;\n    padding: 0;\n\n}\n\n.alert ul li {\n    padding: 0px;\n    font-size: var(--font-size-sm);\n    list-style: none;\n    font-weight:bold;\n    color:var(--black-color) !important;\n}\n\n.field-error {\n    border-radius: 2px 2px 10px 10px;\n    border: 0.15rem solid hotpink;\n    background-color: hotpink;\n    margin-bottom: 10px;\n    margin-top: 2px;\n}\n\n.field-error-input {\n    border-color: hotpink !important;\n}\n\n.field-error ul {\n    margin: 10px;\n    padding: 0;\n}\n\n.field-error li {\n    padding: 0px;\n    font-size: var(--font-size-sm);\n    list-style: none;\n    color: black;\n    font-weight: bold;\n}\n\n.flex-grid {\n    display: flex;\n    flex-wrap: wrap;\n    /*margin: -0.5rem;*/\n}\n\n.col {\n    padding: 0.5rem;\n    box-sizing: border-box;\n}\n\n/* 12-column system */\n.col-1 {\n    flex: 0 0 8.3333%;\n    max-width: 8.3333%;\n}\n\n.col-2 {\n    flex: 0 0 16.6667%;\n    max-width: 16.6667%;\n}\n\n.col-3 {\n    flex: 0 0 25%;\n    max-width: 25%;\n}\n\n.col-4 {\n    flex: 0 0 33.3333%;\n    max-width: 33.3333%;\n}\n\n.col-5 {\n    flex: 0 0 41.6667%;\n    max-width: 41.6667%;\n}\n\n.col-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n}\n\n.col-7 {\n    flex: 0 0 58.3333%;\n    max-width: 58.3333%;\n}\n\n.col-8 {\n    flex: 0 0 66.6667%;\n    max-width: 66.6667%;\n}\n\n.col-9 {\n    flex: 0 0 75%;\n    max-width: 75%;\n}\n\n.col-10 {\n    flex: 0 0 83.3333%;\n    max-width: 83.3333%;\n}\n\n.col-11 {\n    flex: 0 0 91.6667%;\n    max-width: 91.6667%;\n}\n\n.col-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n}\n\n\nhtml {\n    overflow-y: scroll;\n}\n\n\n:root {\n    --pico-h4-color: #c2c7d0 !important;\n    --pico-h5-color: #c2c7d0 !important;\n    --pico-h6-color: #c2c7d0 !important;\n}\n\n/*@property --pico-h6-color {*/\n/*    syntax: \"<color>\";*/\n/*    inherits: false;*/\n/*    initial-value: #f0f1f3;*/\n/*}*/\n\n\nh1, .h1 {\n    font-size: clamp(1.5rem, 5vw, 2rem) !important;\n    line-height: 1.125;\n    --pico-typography-spacing-top: 3rem;\n}\n\nh2, .h2 {\n    font-size: clamp(1.25rem, 4vw, 1.75rem) !important;\n    line-height: 1.15 !important;\n    --pico-typography-spacing-top: 2.625rem;\n}\n\nh3, .h3 {\n    font-size: clamp(1.125rem, 3vw, 1.5rem) !important;\n    line-height: 1.175 !important;\n    --pico-typography-spacing-top: 2.25rem;\n}\n\nh4, .h4 {\n    font-size: clamp(1rem, 2.5vw, 1.25rem) !important;\n    line-height: 1.2 !important;\n    --pico-typography-spacing-top: 1.874rem;\n}\n\nh5, .h5 {\n    font-size: clamp(0.9375rem, 2vw, 1.125rem) !important;\n    line-height: 1.225 !important;\n    --pico-typography-spacing-top: 1.6875rem;\n}\n\nh6, .h6 {\n    font-size: clamp(0.875rem, 1.5vw, 1rem) !important;\n    line-height: 1.25 !important;\n    --pico-typography-spacing-top: 1.5rem;\n}\n\n.h7 {\n    font-size: clamp(0.8125rem, 1.25vw, 0.9375rem) !important;\n    line-height: 1 !important;\n    --pico-typography-spacing-top: 1.3125rem;\n    font-weight: 700 !important;\n}\n\n.h8 {\n    font-size: clamp(0.75rem, 1vw, 0.875rem) !important;\n    line-height: 1 !important;\n    --pico-typography-spacing-top: 1.125rem;\n    font-weight: 700 !important;\n}\n\n\nh1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {\n    font-weight: 700 !important;\n}\n\n/*h1, .h1 {*/\n/*    font-size: 2rem !important;*/\n/*    line-height: 1.125;*/\n/*    --pico-typography-spacing-top: 3rem*/\n/*}*/\n\n/*h2, .h2 {*/\n/*    font-size: 1.75rem !important;*/\n/*    --pico-line-height: 1.15 !important;*/\n/*    --pico-typography-spacing-top: 2.625rem*/\n/*}*/\n\n/*h3, .h3 {*/\n/*    font-size: 1.5rem !important;*/\n/*    --pico-line-height: 1.175 !important;*/\n/*    --pico-typography-spacing-top: 2.25rem*/\n/*}*/\n\n/*h4, .h4 {*/\n/*    font-size: 1.25rem !important;;*/\n/*    line-height: 1.2 !important;;*/\n/*    --pico-typography-spacing-top: 1.874rem*/\n/*}*/\n\n/*h5, .h5 {*/\n/*    font-size: 1.125rem !important;;*/\n/*    line-height: 1.225 !important;;*/\n/*    --pico-typography-spacing-top: 1.6875rem*/\n/*}*/\n\n/*h6, .h6 {*/\n/*    font-size: 1rem !important;;*/\n/*    line-height: 1.25 !important;;*/\n/*    --pico-typography-spacing-top: 1.5rem*/\n/*}*/\n\n.disabled {\n    background: silver;\n    border: 3px solid silver !important;\n    animation: none;\n}\n\n.disabled .animate-content {\n    animation: none\n}\n\n/*nav ul li{*/\n/*    margin:0;*/\n/*    padding:5px;*/\n/*}*/\n\nnav {\n    display: flex;\n    align-items: center; /* <- ensures vertical centering of children */\n    justify-content: space-between;\n    /*background-color: black;*/\n    padding: 0px 0px;\n    /*height: 100%;*/ /* or however tall you want the navbar */\n}\n\nnav li {\n    padding: 10px !important;\n    margin: 0 !important;\n}\n\n\n.page-title {\n    border-bottom: 1px solid #2f2f2f;\n    margin-bottom: 0.5rem;\n}\n\n.page-title h1 {\n    padding: 0px;\n    margin: 0.5rem 0rem;\n}\n\n.container.screen-view{\n    padding:0px;\n    max-width:600px !important;\n}\n\nhtml, body {\n    height: 100%;\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n}\n\nbody > .container {\n    flex: 1 0 auto; /* grow and shrink, but don't disappear */\n    display: flex;\n    flex-direction: column;\n}\n\n#app {\n    flex: 1 0 auto; /* make app area grow to fill vertical space */\n}\n\n#header{\n    padding:0rem 1rem;\n    background-color: #010110;\n    margin-bottom:0.5rem;\n    \n}\n\n.footer {\n    flex-shrink: 0;\n    text-align: center;\n    margin-top: auto;\n    padding: 0.5rem;\n    letter-spacing: 0px;\n    color: lightgray;\n    font-size: .6rem;\n    font-family: 'Helvetica', sans-serif;\n    font-weight: bolder;\n}\n\n\nbody {\n    overflow-y: visible;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
